var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTailwind(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.201355C5.86667 0.201355 4.53333 1.26769 4 3.40036C4.8 2.33402 5.73333 1.93436 6.8 2.20069C7.40867 2.35269 7.84367 2.79436 8.32533 3.28302C9.10933 4.07869 10.017 5.00002 12 5.00002C14.1333 5.00002 15.4667 3.93369 16 1.80069C15.2 2.86702 14.2667 3.26702 13.2 3.00069C12.5917 2.84869 12.1567 2.40702 11.675 1.91836C10.8907 1.12236 9.98267 0.201355 8 0.201355ZM4 5.00002C1.86667 5.00002 0.533333 6.06635 0 8.19936C0.8 7.13302 1.73333 6.73302 2.8 6.99969C3.40833 7.15202 3.84333 7.59335 4.325 8.08169C5.10933 8.87769 6.01733 9.79902 8 9.79902C10.1333 9.79902 11.4667 8.73269 12 6.59969C11.2 7.66602 10.2667 8.06602 9.2 7.79935C8.59133 7.64735 8.15633 7.20569 7.67467 6.71736C6.89067 5.92136 5.983 5.00002 4 5.00002Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwind);
export default __webpack_public_path__ + "static/media/tailwind.b483f044dfb9f10f5e00aba0d0554edd.svg";
export { ForwardRef as ReactComponent };